import '../../assets/App.scss';
import './detailmenu.styles.css';
import '../../assets/globalStyles.css';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import FooterCartMenu from '../../component/FooterCartMenu';
// import FilterOption from '../../component/FilterOption';
import Navbar from '../../component/Navbar';
import {loadState, saveState} from '../../_helpers';
import Layout from '../../component/Layout';

function DetailMenu(props) {
    let navigate = useNavigate();
    const [item, setItem] = useState([{}])
    const [note, setNote] = useState(loadState('item-tenant').description === loadState('item-tenant').item_name ? "" : loadState('item-tenant').description)
    // const [spicy, setSpicy] = useState('Normal');
    // const [foodSize, setFoodSize] = useState('Regular');

    useEffect(() => {
        window.scrollTo(0, 0)
        let itemTenant = loadState("item-tenant") ? loadState("item-tenant") : []
        setItem(itemTenant)
    }, [])

    const addToCart = (id, quantity = 1) => {
        let itemCart = loadState("cart") ? loadState("cart") : []
        let singleItem = loadState("item-tenant") ? loadState("item-tenant") : []

        //Find product from catalog, build object, add to storage
        if (itemCart === null || itemCart.length === 0) {
            let tempItem = singleItem;
            let item = Object.assign({}, tempItem, {quantity: quantity, description: note});

            saveState('cart', [item])
        } else if (itemCart.find(({item_id}) => item_id === singleItem.item_id)) {
            //Item already exists in cart, increase quantity

            let cartObj = loadState('cart');

            let oldItem = itemCart.find(({item_id}) => item_id === singleItem.item_id);
            setNote(oldItem.note)

            let itemIndex = cartObj.findIndex(x => x.item_id === id);
            cartObj[itemIndex] = Object.assign({}, oldItem, {
                quantity: oldItem.quantity,
                description: oldItem.note !== "" ? note : oldItem.note
            });
            saveState('cart', cartObj)
        } else {
            let item = Object.assign({}, singleItem, {quantity: quantity, description: note});

            let cartObj = loadState('cart');
            cartObj.push(item)
            saveState('cart', cartObj)
        }
        navigate("/payment")
    }


    // let existing = loadState('item-tenant');
    // existing = existing ? existing : {};
    // existing['description'] = note;
    // saveState('item-tenant', existing);

    return (
        <Layout>
            <Navbar title={item.name}/>
            <div className="container has-background-white selforder-body-detail-item">

                <figure className="image is-3by2">
                    <img
                        src={loadState("item-pic") === undefined ? "https://bulma.io/images/placeholders/720x240.png" : loadState("item-pic")}
                        alt=""/>
                </figure>

                <section className="section" style={{flex: 1}}>
                    <strong className="pink font-size">
                        {loadState('tenantCategory')}
                    </strong>

                    <p className="pb-1 font-medium has-text-black">
                        {item.item_name}
                    </p>

                    <p className="pb-1">
                        <strong className="font-medium">
                            Note
                        </strong>
                    </p>

                    <div className="control">
                        <input className="input is-hovered" value={note} onChange={(e) => setNote(e.target.value)}
                               type="text" placeholder="Tulis catatan tambahan"/>
                    </div>
                </section>
                <section className="section">
                    <hr/>
                    <FooterCartMenu
                        id={item.item_id}
                        addToCart={addToCart}
                        totalPrice={item.itm_price_fmt}
                        title={'TOTAL HARGA'}
                        textButton={'TAMBAH KE KERANJANG'}
                    />
                </section>
            </div>
        </Layout>
    )
}

export default DetailMenu;
